<h1 mat-dialog-title>{{"generateApiKey.actionLabel.disableLabel.heading" | translate}}</h1>
@if (data.active && !data.passwordPopUp) {
  <div mat-dialog-content class="mb-2">{{"generateApiKey.actionLabel.disableLabel.textLabel" | translate}}</div>
}
@if (!data.active && !data.passwordPopUp) {
  <div mat-dialog-content class="mb-2">{{"generateApiKey.actionLabel.enableLabel.textLabel" | translate}}</div>
}
@if (data.passwordPopUp) {
  <div mat-dialog-content class="mb-2">You password has been changed successfully. Please login with the new password</div>
}
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="space-between" [ngClass]="{'block': data.passwordPopUp}">
  @if (!data.passwordPopUp) {
    <button mat-flat-button color="warn" type="button" id="disableConfirmModelCmp_cancelBtn" (click)="close(false)">{{"cancelButtonLabel" | translate}}</button>
  }
  @if (data.active && !data.passwordPopUp) {
    <button mat-flat-button color="primary" type="button" id="disableConfirmModelCmp_disableBtn" (click)="close(true)">{{"generateApiKey.actionLabel.disableLabel.disableLabel" | translate}}</button>
  }
  @if (!data.active && !data.passwordPopUp) {
    <button mat-flat-button color="primary" type="button" id="disableConfirmModelCmp_enableBtn" (click)="close(true)">{{"generateApiKey.actionLabel.enableLabel.enableLabel" | translate}}</button>
  }
  @if (data.passwordPopUp) {
    <button class="float-right" mat-flat-button color="primary" type="button" id="disableConfirmModelCmp_okBtn" (click)="close(true)">Okay</button>
  }
</div>
